var React = require( 'react' );
var createReactClass = require('create-react-class');
var NumericPicker = require('./numericPicker.jsx');
var PeriodPicker = require('./periodPicker.jsx');

var DurationPicker = createReactClass({

    componentDidMount: function(){
        this.handleChange();
    },

    componentWillReceiveProps: function(nextProps){
        if(this.props.name !== nextProps.name){
            this.handleChange();
        }
    },

    handleChange: function(v, u) {
        v = v || this.getValue();
        u = u || this.getUnit();

      var userResponse = {
          tag: v + '_' + u,
          text: v + ' ' + u,
          value: null
      };
      this.props.response(userResponse);
    },

    handleUnitChange: function(u){
        var vBeforeUnitChanged = this.getValue();
        var changedUnitRangeEnd = this.getUnitRangeEnd(u);
        var v = vBeforeUnitChanged > changedUnitRangeEnd ? changedUnitRangeEnd : vBeforeUnitChanged;
        this.handleChange(v, u);
    },

    handleValueChange: function(v){
        var u = this.getUnit();
        this.handleChange(v, u);
    },

    periods: [
        {"id": 0, "value": "days", "title": "day(s)"},
        {"id": 1, "value": "weeks", "title": "week(s)"},
        {"id": 2, "value": "months", "title": "month(s)"},
        {"id": 3, "value": "years", "title": "year(s)"}
    ],

    unitRange: {
        'days': {
            start: 1,
            end: 31
        },
        'weeks': {
            start: 1,
            end: 52
        },
        'months': {
            start: 1,
            end: 12
        },
        'years': {
            start: 1,
            end: 10
        }
    },

    getUnitRangeStart: function(unit){
        return this.unitRange[unit] ? this.unitRange[unit].start : 1;
    },

    getUnitRangeEnd: function(unit){
        return this.unitRange[unit] ? this.unitRange[unit].end : 30;
    },

    getUnit: function(){
        var splitedTag = this.getUserResponseTag().split('_') || [];
        return splitedTag[1] || 'days';
    },

    getValue: function(){
        var splitedTag = this.getUserResponseTag().split('_') || [];
        return splitedTag[0] || this.getUnitRangeStart('days');
    },

    getUserResponseTag: function(){
        return this.props.currentResponse[0] ? this.props.currentResponse[0].tag : '';
    },

    render: function(){
        var isWhenDidQuestion = (this.props.label + this.props.sublabel).indexOf("When did") >= 0;
        var suffix = isWhenDidQuestion ? ' ago' : '';

        var isHowOftenQuestion = (this.props.label + this.props.sublabel).indexOf("How often") >= 0;
        var prefix = isHowOftenQuestion ? 'Every ' : '';

        var v = this.getValue();
        var u = this.getUnit();

        return (
            <div className="row">
                <div className="duration-picker text-center">
                    {prefix}
                    <div className="select-container">
                        <NumericPicker start={this.getUnitRangeStart(u)} end={this.getUnitRangeEnd(u)} value={v} onChange={this.handleValueChange} />
                    </div>
                    <div className="select-container">
                        <PeriodPicker value={u} periods={this.periods} onChange={this.handleUnitChange} />
                    </div>
                    {suffix}
                </div>
            </div>
        );
    }
});

module.exports = DurationPicker;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/pickers/durationPicker.jsx